<script lang="ts">
	import lightbulb from '$lib/assets/events/lightbulb.svg';
	import Button from '$lib/Button.svelte';
	import { ChevronDown, ChevronUp } from 'lucide-svelte';
	import Checkmark from './Checkmark.svelte';

	interface Props {
		index: number;
		title: string;
		objective: string;
		image: string;
		topics: string[];
		outcome: string;
	}

	let { index, title, objective, image, topics, outcome }: Props = $props();

	let open = $state(false);
</script>

<div>
	<div class="flex items-center gap-8">
		<img src={image} alt="module 1" class="hidden w-96 lg:block" />
		<div>
			<p class="body-bold text-green-primary mb-3">Module {index}</p>
			<p class="h2 mb-3">{title}</p>
			<p class="mb-5">{objective}</p>
			<Button variant="ghost" class="inline-block" click={() => (open = !open)}>
				<span class="text-green-dark">Learn more</span>
				{#if open}
					<ChevronUp class="text-green-dark h-6 w-6" />
				{:else}
					<ChevronDown class="text-green-dark h-6 w-6" />
				{/if}
			</Button>
		</div>
	</div>

	{#if open}
		<div class="card-border mt-3 p-6">
			<p class="text-gray-dark">LESSON TOPICS</p>
			<hr class="border-gray-faint my-3" />
			<ul class="mb-6 grid gap-5">
				{#each topics as topic}
					<li class="flex items-start gap-2">
						<Checkmark fill="#00a87d1e" tickColor="#00a87d" />
						{topic}
					</li>
				{/each}
			</ul>

			<div class="bg-yellow-light rounded-2xl p-5 lg:flex lg:items-center lg:gap-5">
				<img src={lightbulb} alt="lightbulb" class="h-10" />
				<div class="h3">
					<p>Outcome: <span class="hidden lg:inline">{outcome}</span></p>
					<p class="lg:hidden">{outcome}</p>
				</div>
			</div>
		</div>
	{/if}
</div>
